import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Pagination from './Pagination';
import Select, { SelectOption } from './Select';


/**
 * This component is a drop-in replacement for react-table's default pagination.
 * Use it by passing the component to the `PaginationComponent` prop
 *
 * <ReactTable PaginationComponent={ReactTablePagination} ... />
 *
 * All props are automatically provided by ReactTable except shouldShowPageSize
 * and className
 */
export default function ReactTablePagination({
    /** If true, a select with page size options is rendered to the left */
    shouldShowPageSize = true,

    /** optional className added to the outer container */
    className,

    /** The following props are added automatically by ReactTable */
    page,
    pages,
    onPageChange,
    pageSize = 10,
    pageSizeOptions,
    onPageSizeChange
}) {
    if (!pages) {
        return null;
    }

    return (
        <div
            data-component="ReactTablePagination"
            className={cx('sarsa-react-table-pagination', className)}>
            <div>
                {shouldShowPageSize && (
                    <Select
                        id="rows-per=page"
                        label="Rows per page"
                        isInline
                        value={`${pageSize}`}
                        onChange={(e) => onPageSizeChange(parseInt(e.target.value, 10))} >
                        {pageSizeOptions.map((option) => (
                            <SelectOption key={option} value={`${option}`}>
                                {`${option} rows`}
                            </SelectOption>
                        ))}
                    </Select>
                )}
            </div>
            <div>
                {pages > 1 && (
                    <Pagination
                        pages={pages}
                        activePage={page}
                        onChange={onPageChange} />
                )}
            </div>
        </div>
    );
}

ReactTablePagination.propTypes = {
    page: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    pageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    pageSizeOptions: PropTypes.array.isRequired,
    onPageSizeChange: PropTypes.func.isRequired,
    shouldShowPageSize: PropTypes.bool,
    className: PropTypes.string
};
